/**
 * State.js - finite state machine for the experience.
 */

export const States = {
  LOADING: 'LOADING',
  OPENING_SEQUENCE: 'OPENING_SEQUENCE',
  EXPLORING: 'EXPLORING',
  STAR_FOCUSED: 'STAR_FOCUSED',
  DESCENDING: 'DESCENDING',
  EVENT_HORIZON: 'EVENT_HORIZON',
  CROSSING: 'CROSSING',
  POST_FINALE: 'POST_FINALE',
};

export class State {
  constructor() {
    this.current = States.LOADING;
    this.listeners = [];
  }

  set(newState) {
    if (newState === this.current) return;
    const old = this.current;
    this.current = newState;
    for (const listener of this.listeners) {
      listener(newState, old);
    }
  }

  on(listener) {
    this.listeners.push(listener);
    return () => {
      const idx = this.listeners.indexOf(listener);
      if (idx !== -1) this.listeners.splice(idx, 1);
    };
  }

  is(state) {
    return this.current === state;
  }
}
